import { useContext } from "react";
import { Link } from "react-router-dom";
import Hero from "../../components/Hero";
import JobCard from "../../components/JobCard";
import SkeletonCard from "../../components/SkeletonCard";
import { JobContext } from "../../context/JobContext";

const HomePage = () => {
  const { states, actions } = useContext(JobContext);
  const { filteredJobs, loading, error } = states;
  const { normalizeCity, formatRupiah, handleStatus } = actions;

  const LIMIT = 5;
  const displayedData = filteredJobs?.slice(0, LIMIT);
  const remaining = filteredJobs?.length - LIMIT;

  return (
    <div>
      <Hero />

      <div className="my-5 max-w-7xl mx-auto sm:my-10 px-2">
        <hr className="border-gray-200" />
      </div>

      <section id="joblist">
        {" "}
        <div className="flex flex-col gap-10">
          <div className="mx-auto justify-center items-center text-center">
            <h1 className="text-2xl font-semibold leading-snug sm:text-4xl sm:leading-tight">
              Jelajahi Lowongan <br /> Pekerjaan
              <strong className="text-indigo-600"> Terbaik </strong> Kami
            </h1>
          </div>

          <div className="flex flex-wrap gap-4 justify-center max-w-7xl">
            {loading &&
              Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)}

            {!loading && error && (
              <div className="w-full h-24 text-center text-red-500 font-bold">
                {error}
              </div>
            )}

            {!loading &&
              !error &&
              displayedData?.map((job) => (
                <JobCard
                  key={job._id}
                  job={job}
                  normalizeCity={normalizeCity}
                  formatRupiah={formatRupiah}
                  handleStatus={handleStatus}
                />
              ))}

            {!loading && !error && remaining > 0 && (
              <Link
                to="/job-vacancy"
                className="w-full max-w-xs bg-white border-2 border-dashed border-gray-300 rounded-xl p-6 flex flex-col hover:border-indigo-600 hover:bg-indigo-50 transition">
                {" "}
                <div className="flex flex-1 flex-col items-center justify-center text-center">
                  {" "}
                  <p className="text-3xl sm:text-4xl font-bold text-gray-900">
                    {" "}
                    +{remaining}{" "}
                  </p>{" "}
                  <p className="mt-1 text-sm text-gray-600">
                    {" "}
                    Lowongan lainnya menunggu{" "}
                  </p>{" "}
                </div>{" "}
                <div className="pt-4 text-center">
                  {" "}
                  <span className="text-sm font-semibold text-indigo-600">
                    {" "}
                    Lihat Semua Pekerjaan →{" "}
                  </span>{" "}
                </div>{" "}
              </Link>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
